import styled from 'styled-components';
import { colorGray, colorGrey200, colorGrey400, colorWhite } from 'styles';

export const Button = styled.button`
  display: flex;
  align-items: center;
  border-radius: 30px;
  justify-content: center;
  flex: 1;
  font-size: 14px;
  line-height: 32px;
  height: 32px;
  padding: 0 16px 0 12px;
  border: 1px solid ${colorGrey200};
  background-color: ${colorWhite};
  color: ${colorGray};
  white-space: nowrap;
  gap: 4px;

  svg {
    fill: ${colorGray};
  }

  &:hover {
    border: 1px solid ${colorGrey400};
  }
`;
